import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogActions, Button } from '@material-ui/core';

interface ConfirmProps {
    message: string,
    action: () => Promise<any>,
    trigger: string,
}

const Confirm = (props: ConfirmProps) => {
    const [open, setOpen] = useState<boolean>(false);

    return <>
        <Dialog open={open} onClose={() => {
            setOpen(false);
        }}>
            <DialogTitle>{props.message}</DialogTitle>
            <DialogActions>
                <Button color="secondary" onClick={() => {
                    props.action().finally(() => {
                        setOpen(false);
                    });
                }}>Confirmer</Button>
                <Button onClick={() => {
                    setOpen(false);
                }}>Annuler</Button>
            </DialogActions>
        </Dialog>
        <Button onClick={() => {
            setOpen(true);
        }}>
            {props.trigger}
        </Button>
    </>
}

export default Confirm;